import { RootState } from 'typesafe-actions';

export const connectionStartSelector = (state: RootState) => state.websocket.connectionStarted;
